import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { DialogContent as t, AppBar as d } from "@mui/material";
import l from "@mui/material/SwipeableDrawer";
import { makeStyles as f } from "tss-react/mui";
import b from "../../Button/Button.js";
import w from "./SwipeableDrawerBase.style.js";
const B = f()(w);
function D({ children: n }) {
  return /* @__PURE__ */ e(t, { sx: { padding: 2 }, children: n });
}
function x({
  children: n,
  onClose: i,
  customStyle: a
}) {
  const { classes: r } = B();
  return /* @__PURE__ */ e(d, { position: "static", style: a == null ? void 0 : a.appBar, children: /* @__PURE__ */ s("div", { className: r.banner, style: a == null ? void 0 : a.banner, children: [
    /* @__PURE__ */ e(
      b,
      {
        className: r.expandBtn,
        style: a == null ? void 0 : a.expandBtn,
        dataTestid: "dialogExpandBtn",
        onClick: i
      }
    ),
    n
  ] }) });
}
const o = ({
  isOpen: n,
  dataTestid: i = "Lumi-swipeable-drawer",
  children: a,
  onClose: r,
  ...p
}) => /* @__PURE__ */ e(
  l,
  {
    anchor: "bottom",
    open: n,
    onClose: r,
    onOpen: null,
    "data-testid": i,
    disableDiscovery: !0,
    ...p,
    children: a
  }
);
o.Header = x;
o.Content = D;
const v = o;
export {
  v as default
};
